import { Container, Row, Col } from 'react-bootstrap';
import ColumnsCustomLegend from '../../components/ApexCharts/CustomLegends/ColumnsCustomLegend';
import GenericCard from '../../components/GenericCards/GenericCards';
import Blockquote from '../../components/Blockquote';
import Button from '../../components/Button';
import ColumnsChart from '../../components/ApexCharts/ColumnsChart';
import { useNavigate } from 'react-router-dom';
import { OPTIMIZER_ROUTE } from '../../routes/types';

const legendData = {
  colors: ['#074CBC', '#07B4A0'],
  series: [
    {
      name: 'Current Financial Well-Being',
      data: [48],
    },
    {
      name: 'Optimal Financial Well-Being',
      data: [61],
    },
  ],
};

const columnChartData = {
  chart: {
    stacked: true,
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  },
  series: [
    {
      data: [
        {
          x: 'Current Financial Well-Being',
          y: 48,
          fillColor: '#074CBC',
        },

        {
          x: 'Optimal Financial Well-Being',
          y: 61,
          fillColor: '#07B4A0',
        },
      ],
    },
  ],

  dataLabels: {
    enabled: false,
  },
  fill: {
    opacity: 1,
  },
  legend: {
    show: true,
  },
  plotOptions: {
    bar: {
      horizontal: false,
    },
  },
  responsive: [
    {
      breakpoint: 480,
      options: {
        legend: {
          position: 'bottom',
          offsetX: -10,
          offsetY: 0,
        },
      },
    },
  ],
  tooltip: {
    enabled: false,
  },
  xaxis: {
    overwriteCategories: [],
  },
  yaxis: {
    title: {
      text: '',
    },
    min: 0,
    max: 70,
    tickAmount: 7,
  },
};

const assumptionsData = [
  {
    category: 'Retirement Contribution to Earn Employer Match',
    currentValue: '$200',
    optimizedValue: '$317',
  },

  {
    category: 'Additional Retirement Contribution',
    currentValue: '$0',
    optimizedValue: '$495',
  },

  {
    category: 'Health Savings Contribution',
    currentValue: '$0',
    optimizedValue: '$388',
  },

  {
    category: 'Debt Reduction',
    currentValue: '$0',
    optimizedValue: '$0',
  },

  {
    category: 'Savings',
    currentValue: '$0',
    optimizedValue: '$0',
  },
];

const OptimizerScore = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <Row className={'py-10 py-lg-11 align-items-center'}>
        <Col className={'col-6'}>
          <span className={'lh-sm text-sm-20-lg-32'}>
            Financial Well-being Score
          </span>
        </Col>
        <Col className={'col-6 text-end'}>
          <Button onClick={() => navigate(OPTIMIZER_ROUTE)}>Edit Budget</Button>
        </Col>
      </Row>

      <Row className="d-flex justify-content-between m-0 p-0">
        <Col className="m-0 p-0 d-flex flex-column col-12 col-lg-7 pe-lg-4">
          <GenericCard variant={'white'}>
            <Container className={'px-0'}>
              <Row className={'mb-11'}>
                <Col className={'col-12 mb-7'}>
                  <span
                    className={
                      'lh-xs text-sm-16-lg-24 text-dark-gray fw-normal-sm-light-lg'
                    }
                  >
                    Assumptions
                  </span>
                </Col>

                <Col className={'col-12'}>
                  <Blockquote>
                    <span
                      className={'lh-xxs text-fs-6 fw-light text-dark-gray'}
                    >
                      These scores represent your current and potential
                      financial well being with a maximum possible score of 100.
                      We prioritize retirement savings, debt reduction and
                      finally other savings. Below are the suggested changes to
                      help optimize your budget and improve your score.
                    </span>
                  </Blockquote>
                </Col>
              </Row>

              <Container className={'px-0 overflow-auto'}>
                <Row className={'mx-0'} style={{ minWidth: 682 }}>
                  <Col className={'col-12 py-3 border-bottom-light-gray-2px '}>
                    <Row>
                      <Col className={'col-6'}>
                        <span
                          className={
                            'lh-xxs text-fs-6 fw-normal text-dark-gray'
                          }
                        >
                          Category
                        </span>
                      </Col>

                      <Col className={'col-3 text-end'}>
                        <span
                          className={
                            'lh-xxs text-fs-6 fw-normal text-dark-gray'
                          }
                        >
                          Current Value
                        </span>
                      </Col>

                      <Col className={'col-3 text-end'}>
                        <span
                          className={
                            'lh-xxs text-fs-6 fw-normal text-dark-gray'
                          }
                        >
                          Optimized Value
                        </span>
                      </Col>
                    </Row>
                  </Col>

                  {assumptionsData.map((data, idx) => (
                    <Col
                      key={idx}
                      className={'py-3 col-12 border-bottom-light-gray-lg'}
                    >
                      <Row>
                        <Col className={'col-6'}>
                          <span
                            className={
                              'lh-xxs text-fs-6 fw-light text-dark-gray'
                            }
                          >
                            {data.category}
                          </span>
                        </Col>

                        <Col className={'col-3 text-end'}>
                          <span
                            className={
                              'lh-xxs text-fs-6 fw-light text-dark-gray'
                            }
                          >
                            {data.currentValue}
                          </span>
                        </Col>

                        <Col className={'col-3 text-end'}>
                          <span
                            className={
                              'lh-xxs text-fs-6 fw-light text-dark-gray'
                            }
                          >
                            {data.optimizedValue}
                          </span>
                        </Col>
                      </Row>
                    </Col>
                  ))}
                </Row>
              </Container>
            </Container>
          </GenericCard>
        </Col>

        <Col className={'mt-10 mt-lg-0 pe-lg-0 col-12 col-lg-5'}>
          <GenericCard variant={'white'}>
            <Row>
              <Col className={'col-12'}>
                <ColumnsChart
                  series={columnChartData.series}
                  options={columnChartData}
                />
              </Col>

              <Col className={'col-12 px-11'}>
                <ColumnsCustomLegend
                  isPrice={false}
                  series={legendData.series}
                  colors={legendData.colors}
                />
              </Col>
            </Row>
          </GenericCard>
        </Col>
      </Row>
    </Container>
  );
};

export default OptimizerScore;
